import { render, staticRenderFns } from "./teacher-add-upload.vue?vue&type=template&id=4ef4bbbc&scoped=true"
import script from "./teacher-add-upload.vue?vue&type=script&lang=js"
export * from "./teacher-add-upload.vue?vue&type=script&lang=js"
import style0 from "./teacher-add-upload.vue?vue&type=style&index=0&id=4ef4bbbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4bbbc",
  null
  
)

export default component.exports